import React, { Component } from 'react';
import Uppy from '@uppy/core';
import AwsS3 from "@uppy/aws-s3";
import DragDrop from '@uppy/drag-drop';
import ProgressBar from '@uppy/progress-bar';
import { toast } from 'react-toastify';
import _ from "lodash";
import '@uppy/core/dist/style.css';
import '@uppy/progress-bar/dist/style.css';
import { BRANDING } from "../../constants/Branding"
import './ImageUploader.scss';

const SOURCE = {
  DRAGDROP_LOGO: "dragdrop-logo",
  DRAGDROP_FAVICON: "dragdrop-favicon",
  DRAGDROP_SITE_IMAGE: "dragdrop-siteImage",
};

const CC_COMPANION_URL = process.env.REACT_APP_COMPANION_URL; // Transloadit.COMPANION;
class ImageUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageUrl: props.imageUrl || null,
    };

    this.uppy = null;
  }

  componentDidMount() {
    const { uppy, type } = this.props;
    if (!uppy) {
      console.error("Uppy instance not provided");
      return;
    }
    if (uppy) {
      // console.log({ type, props: this.props, info: "ImageUploader uppy" });
      uppy.use(DragDrop, { id: `dragdrop-${type}`, target: `.UppyDragDrop-${type}` })
          .use(ProgressBar, { id: `dragdropProgress-${type}`, target: `.UppyDragDrop-Progress-${type}`, hideAfterFinish: true });
      
      uppy.on('file-added', (file) => { // global event
        // console.log({info:"file-added", file, type, id: uppy.id});
        if (file.source === `dragdrop-${type}`) { // trigger just for this control
          uppy.setFileMeta(file.id, { sourceType: type });
          // console.log({info:"file-added", file, type, id: uppy.id});
          const fileUrl = URL.createObjectURL(file.data);
          this.setState({ imageUrl: fileUrl });
          if (this.props.onImageUpdate) {
            this.props.onImageUpdate(fileUrl);
          }
        }
    });
    }
    // this.uppy = new Uppy({
    //   id: this.props.id || null,
    //   debug: true,
    //   autoProceed: this.props.autoProceed || false,
    //   allowMultipleUploadBatches: false,
    //   restrictions: {
    //     allowedFileTypes: ["image/*"],
    //   },
    //   onBeforeFileAdded: this.setFileNameAndPath,
    // });

    // this.uppy
    //   .use(DragDrop, { target: `.UppyDragDrop-${this.props.type}` })
    //   .use(ProgressBar, { target: `.UppyDragDrop-Progress-${this.props.type}`, hideAfterFinish: true })
    //   .use(AwsS3, {
    //     limit: 1,
    //     timeout: 60000,
    //     companionUrl: CC_COMPANION_URL,
    //   });

    // this.uppy.on("file-added", (file) => {
    //   console.log({info:"file-added", file, id: this.uppy.id});
    //   const fileUrl = URL.createObjectURL(file.data);
    //   this.setState({ imageUrl: fileUrl });
    //   this.props.onImageUpdate(fileUrl);

    //   if (this.props.setFileBlob) {
    //     this.props.setFileBlob(file);
    //   }
    // });

    // this.uppy.on("complete", (result) => {
    //   console.log({info:"complete", id: this.uppy.id, result, files: this.uppy.getFiles()});
    //   if (result.failed.length === 0) {
    //     // console.log({ result });
    //     const finalUrl = result.successful[0].uploadURL;
    //     this.setState({ imageUrl: finalUrl });
    //     this.props.onImageUpdate(finalUrl);
    //     // toast.success("Uploaded successfully", {
    //     //   position: toast.POSITION.TOP_RIGHT
    //     // });

    //     if (this.props.onUploadSuccess) {
    //       this.props.onUploadSuccess();
    //     }
    //   } else {
    //     toast.error(`Failed to upload ${this.props.type}. Please try again later`, {
    //       position: toast.POSITION.TOP_RIGHT,
    //     });
    //   }
    // });

    // if (this.props.setUppy) {
    //   this.props.setUppy(this.uppy);
    // }
  }

  componentDidUpdate(prevProps) {
    // If the parent updated imageUrl (e.g. after an S3 upload),
    // override local state so that we see the "final" URL.
    if (prevProps.imageUrl !== this.props.imageUrl) {
      this.setState({ imageUrl: this.props.imageUrl });
    }
  }

  /**
   * Given a new file is being added to upload, then process the name of the file
   * @param {*} currentFile - the file to be added
   * @param {*} files -- the files already added
   */
  setFileNameAndPath = (currentFile, files) => {
    const modifiedFile = {
      ...currentFile,
      // file name like /DEVca675b28c1f047e1891df9e102572401/branding/0e27daec-7d63-42bc-a05a-3512186f4b3b/site-image.jpg
      // we don't include an extension here
      name: `${this.props.tenantId}/${this.props.type}/${this.props.typeId}/${this.props.type}-image`,
    };
    // console.log({name:modifiedFile.name});
    return modifiedFile;
  };

  onChangeImage = () => {
    const uploadBtn = document.querySelector(`.image-uploader-container-${this.props.type} .uppy-DragDrop-input`);
    if (uploadBtn) {
      uploadBtn.click();
    }
  };

  render() {
    let imageUrl = null;

    if (this.state.imageUrl) {
      imageUrl = this.state.imageUrl;
    } else if (this.props.imageUrl) {
      if (this.props.type === BRANDING.LOGO) {
        imageUrl = this.props.imageUrl;
      } else if (this.props.type === BRANDING.FAVICON) {
        // migrate away from old pathing
        imageUrl = _.get(
          this.props.imageUrl,
          "['favicon-32'][0]['ssl_url']",
          _.get(this.props.imageUrl, "['favicon-32']", this.props.imageUrl)
        );
      } else if (this.props.type === BRANDING.SITE_IMAGE) {
        // migrate away from old pathing
        imageUrl = _.get(this.props.imageUrl, "[':original'][0]['ssl_url']", this.props.imageUrl);
        if (typeof imageUrl !== "string") {
          imageUrl = "";
        }
      }
    }

    return (
      <div className={`image-uploader-container image-uploader-container-${this.props.type}`}>
        {imageUrl ? (
          <div>
            <div className={`UppyDragDrop-${this.props.type} no-image`} />
            <img
              src={imageUrl}
              className={`UppyDragDrop-${this.props.type}`}
              alt="preview"
              onClick={this.onChangeImage}
            />
          </div>
        ) : (
          <div className={`UppyDragDrop-${this.props.type} no-image`} />
        )}
        <div className={`UppyDragDrop-Progress-${this.props.type}`} />
      </div>
    );
  }
}

export default ImageUploader;
